import createClient, { Client } from 'openapi-fetch'

import getRestApiUrl from '@kidzonet/get-rest-api-url'
import { authenticate, getAuthInfo, refresh, revoke, signUpUser } from '@kidzonet/ts-api-dashboard-auth'
import type { paths } from '@kidzonet/ts-api-generator/clients/auth'
import { AuthMiddleware, ErrorHandlingMiddleware, getRefreshToken } from '@kidzonet/ts-api-localstorage-middleware'

declare global {
    // eslint-disable-next-line vars-on-top
    var DashboardAuthApiClient: Client<paths>
}

export default () => {
    window.DashboardAuthApiClient = createClient<paths>({ baseUrl: getRestApiUrl() })
    window.DashboardAuthApiClient.use(AuthMiddleware)
    window.DashboardAuthApiClient.use(ErrorHandlingMiddleware)

    window.NEW_AUTH_API = {
        authenticate,
        getAuthInfo,
        refresh,
        revoke,
        signUpUser,
    }

    window.getRefreshToken = getRefreshToken
}
